import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControlProps,
  useColorScheme,
} from "@mui/material";

import { useContext } from "react";
import { BNThemeMode } from "../../bnMuiTheme";

interface Props {
  sx?: FormControlProps["sx"];
}

export const BNThemeSelector: React.FC<Props> = ({ sx }) => {
  const { darkThemeEnabled, locale } = useContext(BNThemeMode);
  const { mode: muiMode, setMode } = useColorScheme();

  if (!darkThemeEnabled) {
    return;
  }

  const labels = resolveThemeLabels(locale);

  return (
    <FormControl sx={sx}>
      <FormLabel id="theme-toggle">{labels.colorMode}</FormLabel>
      <RadioGroup
        aria-labelledby="theme-toggle"
        name="theme-toggle"
        row
        value={muiMode}
        onChange={(event) => setMode(event.target.value as "system" | "light" | "dark")}
      >
        <FormControlLabel value="dark" control={<Radio />} label={labels.dark} />
        <FormControlLabel value="light" control={<Radio />} label={labels.light} />
        <FormControlLabel value="system" control={<Radio />} label={labels.system} />
      </RadioGroup>
    </FormControl>
  );
};

export default BNThemeSelector;

interface ThemeLabels {
  colorMode: string;
  dark: string;
  light: string;
  system: string;
}

const resolveThemeLabels = (locale?: string): ThemeLabels => {
  const translations: { [key: string]: ThemeLabels } = {
    "nb-NO": { colorMode: "Fargemodus", dark: "Mørk", light: "Lys", system: "System" },
    "sv-SE": { colorMode: "Färgläge", dark: "Mörk", light: "Ljus", system: "System" },
    "da-DK": { colorMode: "Farvetilstand", dark: "Mørk", light: "Lys", system: "System" },
    "fi-FI": { colorMode: "Väriteema", dark: "Tumma", light: "Vaalea", system: "Järjestelmä" },
    "sv-FI": { colorMode: "Färgläge", dark: "Mörk", light: "Ljus", system: "System" },
    "es-ES": { colorMode: "Modo de color", dark: "Oscuro", light: "Claro", system: "Sistema" },
    "de-DE": { colorMode: "Farbmodus", dark: "Dunkel", light: "Hell", system: "System" },
  };

  return locale && translations[locale]
    ? translations[locale]
    : { colorMode: "Color mode", dark: "Dark", light: "Light", system: "System" };
};
